
import AboutHero from "src/sections/terms-and-conditions/about/about-hero";
import AboutWhat from "src/sections/terms-and-conditions/about/about-what2";
import { useGetPrivacyPolicyQuery } from "src/store/Reducer/adminSetting";

const PrivacyPolicyView = () => {

    const { data, isLoading } = useGetPrivacyPolicyQuery({ language: 'en' });

    return (
        <div>
            <AboutHero data={{ title: "Our", list: [("Privacy Policy ")] }} />
            <AboutWhat isLoading={isLoading} data={{ title: "", content: data?.text, image: '/assets/privacy-policy.jpeg' }} />
        </div>
    )
}

export default PrivacyPolicyView
